@if (interactive) {
  <button
    type="button"
    class="toggle-switch"
    [class.enabled]="checked"
    [class.soft-disabled]="softDisabled"
    [class.warning]="tone === 'warning'"
    [disabled]="disabled"
    [attr.aria-pressed]="checked"
    [attr.aria-disabled]="disabled || softDisabled ? 'true' : null"
    [attr.aria-label]="ariaLabel || null"
    (click)="onClick()"
  >
    <span class="knob"></span>
  </button>
} @else {
  <span class="toggle-switch" [class.enabled]="checked" [class.warning]="tone === 'warning'" aria-hidden="true">
    <span class="knob"></span>
  </span>
}
